import {FieldsForm} from '../../../fields/types'
import {OrderDto} from '../../types'
import {getUeCcVariationCodeAdjustedTime} from '../variationCode/getUeCcVariationCodeAdjustedTime'

/**
 * Produces the "working" form values that seed react-hook-form's reactive `values` while the
 * original `buildForm` output stays the `defaultValues` (dirty-comparison baseline).
 *
 * For an unconfirmed UE/CC order with a non-zero offset, the order time is pre-filled with the
 * rescheduled `variationCodeAdjustedTime`. Because the default remains the original schedule time,
 * the `dateTime` field is reported dirty — which (a) emits `shippingDate = adjustedTime` in the
 * change request and (b) renders the original time struck-through in Final Review.
 *
 * Returns the SAME `form` reference when no override applies, so callers can cheaply detect whether
 * a working override exists (`workingForm !== form`) and only engage the reactive `values` path then.
 */
export const buildWorkingForm = (order: OrderDto, form: FieldsForm): FieldsForm => {
  const adjustedTime = getUeCcVariationCodeAdjustedTime(order)
  if (!adjustedTime) {
    return form
  }

  return {
    ...form,
    dateTime: [adjustedTime, ...form.dateTime.slice(1)]
  }
}
